import { parse } from './autoSql';
import * as types from './as/autoSqlSchemas';
export default Object.fromEntries(Object.entries(types).map(([key, val]) => [
    key,
    parse(val.trim()),
]));
//# sourceMappingURL=defaultTypes.js.map